import { useTranslation } from 'next-i18next';

import styles from './InfoCard.module.scss';

import { P4 } from '../../Typography';

export interface IInfoCard {
  digit: string;
  text: string;
}
export const InfoCard = ({ digit, text }: IInfoCard) => {
  const { t } = useTranslation('index');
  return (
    <div className={styles.card}>
      <p className={styles.card__digit}>{digit}</p>
      <P4 className={styles.card__text}>{t(text)}</P4>
    </div>
  );
};
